import { Box, Typography, alpha, useTheme } from "@mui/material";
import {
  Business as BusinessIcon,
  Schedule as ScheduleIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";

export const CardDadosCriacaoModern = () => {
  const { valueContractInternal } = useContextContrato();

  if (!valueContractInternal) return null;

  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;

  const { nome_filial, created_at, update_at } = valueContractInternal;

  const items = [
    {
      icon: <BusinessIcon />,
      label: "Filial",
      value: nome_filial,
      color: primaryColor,
    },
    {
      icon: <ScheduleIcon />,
      label: "Criado em",
      value: FormatDateBR(created_at),
      color: "#10b981",
    },
    {
      icon: <EditIcon />,
      label: "Editado em",
      value: FormatDateBR(update_at),
      color: "#f59e0b",
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: { xs: 2, md: 4 },
        p: { xs: 2, sm: 3 },
        bgcolor: alpha("#64748b", 0.05),
        borderRadius: "16px",
        border: "1px solid",
        borderColor: alpha("#64748b", 0.1),
      }}
    >
      {items.map((item) => (
        <Box
          key={item.label}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 36,
              height: 36,
              borderRadius: "10px",
              bgcolor: alpha(item.color, 0.1),
              color: item.color,
              "& svg": { fontSize: 20 },
            }}
          >
            {item.icon}
          </Box>
          <Box>
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                fontSize: "11px",
                fontWeight: 500,
                textTransform: "uppercase",
                letterSpacing: 0.5,
                display: "block",
              }}
            >
              {item.label}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "text.primary",
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {item.value || "-"}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
